module.exports = __webpack_public_path__ + "static/media/education-min.15df8ed6.jpg";